var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headers',{ref:"headers",on:{"trigger":_vm.trigger,"openReturnWater":_vm.openReturnWater,"openVip":_vm.openVip}}),_c('router-view',{ref:"trigger",on:{"switchTab":_vm.switchTab}}),_c('ReturnWater',{ref:"returnWater",on:{"refresh":_vm.refresh,"reReturnWaterDetail":_vm.reReturnWaterDetail}}),_c('VipList',{ref:"vipList"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }